module.exports = __webpack_public_path__ + "850f0c07c61c4f9c7abe5eaff064df82.svg";